import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { useTranslation } from '../../i18n/translations';
import '../../styles/desktopFooter.css';

/** Footer privacy solo desktop — su tutte le pagine con Layout */
const DesktopFooter = () => {
  const { language } = useLanguage();
  const { t } = useTranslation(language);

  return (
    <footer className="desktop-footer" aria-label="Privacy">
      <Link to="/privacy" className="desktop-footer__privacy">
        {t('privacy.linkLabel')}
      </Link>
    </footer>
  );
};

export default DesktopFooter;
